import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header: React.FC = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo" onClick={closeMenu}>
          <img src="/logo.png" alt="Sykkelfest" className="header-logo-img" />
          <h1>Sykkelfest</h1>
        </Link>

        <button 
          className={`menu-toggle ${menuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
          {!isAuthenticated ? (
            <>
              <NavLink to="/faq" className="nav-link" onClick={closeMenu}>
                <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
                FAQ
              </NavLink>
              <Link to="/logg-inn" className="btn btn-secondary" onClick={closeMenu}>
                Logg inn
              </Link>
            </>
          ) : (
            <>
              <span className="nav-username">Hei, {user?.name}</span>
              {user?.role === 'admin' && (
                <NavLink to="/admin/dashboard" className="nav-link" onClick={closeMenu}>
                  <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                    <path d="M2 17l10 5 10-5"/>
                    <path d="M2 12l10 5 10-5"/>
                  </svg>
                  Administrasjon
                </NavLink>
              )}
              {(user?.role === 'organizer' || user?.role === 'admin') && (
                <NavLink to="/arrangor/dashboard" className="nav-link" onClick={closeMenu}>
                  <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                  Arrangør
                </NavLink>
              )}
              {/* All authenticated users see participant options */}
              <NavLink to="/deltaker/mine-fester" className="nav-link" onClick={closeMenu}>
                <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                Mine Sykkelfester
              </NavLink>
              <NavLink to="/deltaker/profil" className="nav-link" onClick={closeMenu}>
                <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Min Profil
              </NavLink>
              <NavLink to="/faq" className="nav-link" onClick={closeMenu}>
                <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
                FAQ
              </NavLink>
              <div className="nav-divider"></div>
              <button onClick={() => { logout(); closeMenu(); }} className="btn btn-secondary">
                Logg ut
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
